<template>
  <div>
    <div class="row form-group">
      <div class="col-md-12">
        <base-input
          :placeholder="placeholder"
          class="input-group-alternative mb-3"
          v-model="pass"
          type="password"
          addon-left-icon="fa fa-fw fa-unlock-alt"
        ></base-input>
      </div>
    </div>
    <div style="margin-bottom:20px; color:red">
      <div v-if="!isValid.Length && passChanged">{{message.Length}}</div>
      <div v-if="!isValid.UpperCase && passChanged">{{message.UpperCase}}</div>
      <div v-if="!isValid.LowerCase && passChanged">{{message.LowerCase}}</div>
      <div v-if="!isValid.Number && passChanged">{{message.Number}}</div>
      <div v-if="!isValid.SpecialChar && passChanged">{{message.SpecialChar}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "password-validator",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "Contraseña"
    }
  },
  data() {
    return {
      pass: this.value,
      initialPass: this.value, // Guarda el valor inicial del password
      passChanged: false, // Flag para indicar si el password ha sido modificado
      message: {
        Length: "La contraseña debe tener al menos 8 caracteres",
        UpperCase: "La contraseña debe contener al menos una letra mayúscula",
        LowerCase: "La contraseña debe contener al menos una letra minúscula",
        Number: "La contraseña debe contener al menos un número",
        SpecialChar: "La contraseña debe contener al menos un carácter especial"
      },
      isValid: {
        Length: true,
        UpperCase: true,
        LowerCase: true,
        Number: true,
        SpecialChar: true
      }
    };
  },
  watch: {
    pass: function() {
      if (this.pass !== this.initialPass) {
        this.passChanged = true; // Solo si el password cambió del valor inicial
      } else {
        this.passChanged = false;
      }
      this.validatePassword();
    },
    // Observamos cambios en la prop value y actualizamos pass si es diferente
    value(newValue) {
      if (newValue !== this.pass) {
        this.pass = newValue;
        this.initialPass = newValue;
      }
    }
  },
  methods: {
    validatePassword() {
      if (!this.passChanged) {
        this.$emit("password-validated", true);
        return;
      }

      const regexLength = /^.{8,}$/;
      const regexUpperCase = /[A-Z]/;
      const regexLowerCase = /[a-z]/;
      const regexNumber = /\d/;
      const regexSpecialChar = /[@$!%*?&]/;

      this.isValid.Length = regexLength.test(this.pass);
      this.isValid.UpperCase = regexUpperCase.test(this.pass);
      this.isValid.LowerCase = regexLowerCase.test(this.pass);
      this.isValid.Number = regexNumber.test(this.pass);
      this.isValid.SpecialChar = regexSpecialChar.test(this.pass);

      this.$emit(
        "password-validated",
        Object.values(this.isValid).every(val => val)
      );
      this.$emit("input", this.pass); // Emitimos el valor de la contraseña
    }
  }
};
</script>
